enum ROLE {
	DEFAULT = 0,
	LOCATAIRE = 221310003,
	COLOCATAIRE = 221310007,
}

export default ROLE
